export const VDP = 'VDP';
export const SRP = 'SRP';
